import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = { class: "form-contents" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12" };
const _hoisted_10 = { class: "card bg-white detached p-3 mb-3" };
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_13 = { class: "invalid-feedback" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_15 = {
    key: 0,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_16 = { class: "card bg-white detached p-3 mb-3" };
const _hoisted_17 = {
    key: 1,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_18 = { class: "card bg-white detached p-3" };
const _hoisted_19 = { class: "clearfix bottom10" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_21 = { class: "d-flex" };
const _hoisted_22 = { class: "table table-hover bottom0" };
const _hoisted_23 = { class: "hidden-sm" };
const _hoisted_24 = { class: "hidden-sm" };
const _hoisted_25 = { class: "hidden-sm" };
const _hoisted_26 = { class: "text-end" };
const _hoisted_27 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_multiselect = _resolveComponent("multiselect");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
            ]),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save,
                            disabled: _ctx.working
                        }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "disabled"]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _cache[39] || (_cache[39] = _createTextVNode()),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[8] || (_cache[8] = _createElementVNode("label", null, "Name *", -1 /* CACHED */)),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.group.name,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.group.name) = $event)),
                                    name: "name",
                                    maxlength: "100",
                                    class: _normalizeClass({ 'is-invalid': _ctx.nameMissing })
                                }, null, 8 /* PROPS */, ["modelValue", "class"]),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _withDirectives(_createElementVNode("div", _hoisted_13, "\r\n\t\t\t\t\t\t\t\t\t* Please enter a name\r\n\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.nameMissing]
                                ])
                            ]),
                            _cache[13] || (_cache[13] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_14, [
                                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createVNode(_component_b_form_textarea, {
                                    modelValue: _ctx.group.description,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.group.description) = $event)),
                                    name: "description",
                                    maxlength: "500",
                                    rows: "2"
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ])
                        ])
                    ])
                ]),
                _cache[37] || (_cache[37] = _createTextVNode()),
                (!_ctx.isNew)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "mt-0" }, "Features", -1 /* CACHED */)),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted" }, "Members of this group can use the features switched on here. Click Save to apply changes.", -1 /* CACHED */)),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: feature.name,
                                    class: "checkbox-wrapper"
                                }, [
                                    _createVNode(_component_b_form_checkbox, {
                                        id: 'feature-' + feature.name,
                                        modelValue: _ctx.enabledFeatures,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.enabledFeatures) = $event)),
                                        value: feature.name,
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(feature.displayName), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "value"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[38] || (_cache[38] = _createTextVNode()),
                (!_ctx.isNew)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "mt-0" }, "Members", -1 /* CACHED */)),
                            _cache[35] || (_cache[35] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _cache[23] || (_cache[23] = _createElementVNode("label", null, "Add members", -1 /* CACHED */)),
                                    _cache[24] || (_cache[24] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_multiselect, {
                                            modelValue: _ctx.selectedUser,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.selectedUser) = $event)),
                                            options: _ctx.userOptions,
                                            showLabels: false,
                                            openDirection: "below",
                                            "track-by": "userId",
                                            label: "text",
                                            placeholder: "Select a user",
                                            class: "flex-grow-1 me-2",
                                            disabled: _ctx.working
                                        }, {
                                            noResult: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            noOptions: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo more users can be added\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "options", "disabled"]),
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            class: "flex-shrink-0 text-nowrap align-self-start",
                                            onClick: _ctx.addSelectedMember,
                                            disabled: _ctx.working || !_ctx.selectedUser
                                        }, {
                                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                    _createElementVNode("span", { class: "hidden-xs" }, " Add", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick", "disabled"])
                                    ])
                                ])
                            ]),
                            _cache[36] || (_cache[36] = _createTextVNode()),
                            _createElementVNode("table", _hoisted_22, [
                                _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Name"),
                                        _createTextVNode(),
                                        _createElementVNode("th", { class: "hidden-sm" }, "User Name"),
                                        _createTextVNode(),
                                        _createElementVNode("th", { class: "hidden-sm" }, "Role"),
                                        _createTextVNode(),
                                        _createElementVNode("th", { class: "hidden-sm" }, "Companies"),
                                        _createTextVNode(),
                                        _createElementVNode("th", { class: "w120" })
                                    ])
                                ], -1 /* CACHED */)),
                                _cache[32] || (_cache[32] = _createTextVNode()),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.members, (member) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: member.userId
                                        }, [
                                            _createElementVNode("td", null, _toDisplayString(member.fullName), 1 /* TEXT */),
                                            _cache[26] || (_cache[26] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(member.userName), 1 /* TEXT */),
                                            _cache[27] || (_cache[27] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_24, _toDisplayString(member.roleName), 1 /* TEXT */),
                                            _cache[28] || (_cache[28] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.companiesText(member)), 1 /* TEXT */),
                                            _cache[29] || (_cache[29] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_26, [
                                                _createVNode(_component_b_button, {
                                                    size: "sm",
                                                    variant: "outline-danger",
                                                    onClick: ($event) => (_ctx.removeMember(member)),
                                                    disabled: _ctx.working
                                                }, {
                                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                            _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                            _createTextVNode(" Remove\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick", "disabled"])
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _cache[33] || (_cache[33] = _createTextVNode()),
                                _createElementVNode("tfoot", null, [
                                    (!_ctx.group.members || !_ctx.group.members.length)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [...(_cache[30] || (_cache[30] = [
                                                _createElementVNode("td", {
                                                    class: "text-center",
                                                    colspan: "5"
                                                }, [
                                                    _createElementVNode("h5", null, "This group has no members.")
                                                ], -1 /* CACHED */)
                                            ]))]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
